var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collaborators__panel-body" },
    [
      _c("div", { staticClass: "collaborators-width" }, [
        _c(
          "div",
          { staticClass: "collaborators__title" },
          [
            _c("h3", [_vm._v(_vm._s(_vm.collaboratorsTitle))]),
            _vm.buttonAddColaborator
              ? _c(
                  "v-btn",
                  {
                    staticClass: "primary-button uppercase",
                    attrs: { small: "" },
                    on: {
                      click: function($event) {
                        _vm.openNewItem()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.buttonNewCollaborator))]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._l(_vm.listOfChannel, function(boss, index) {
        return _c("ListItem", {
          key: boss.id,
          ref: "listItem",
          refInFor: true,
          attrs: {
            team: boss,
            index: boss.value,
            typeOfTable: { typeOfTable: _vm.typeOfTable },
            additionButtonVisibility: true,
            withCompleteTableFields: false
          },
          on: {
            showChannels: function($event) {
              _vm.showChannels(boss.value)
            },
            editThisChannel: function($event) {
              _vm.editThisChannel(boss.value)
            },
            addNewItem: function($event) {
              _vm.addNewItem(boss)
            },
            toDetailTable: _vm.toDetailTable
          }
        })
      }),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.conditionalNotContent,
              expression: "conditionalNotContent"
            }
          ],
          staticStyle: { "text-align": "center" }
        },
        [_vm._v(_vm._s(_vm.messageNotContent))]
      ),
      _c("newTeamModal", {
        ref: "newTeamModal",
        on: {
          completeForm: _vm.completeForm,
          updateShowChannels: _vm.updateShowChannels
        }
      }),
      _c("editChannelModal", {
        ref: "editChannelModal",
        on: {
          completeForm: _vm.completeForm,
          upDateListBoss: _vm.upDateListBoss
        }
      }),
      _c("newSellerModal", {
        ref: "newSellerModal",
        on: {
          completeForm: _vm.completeForm,
          upDateListBoss: _vm.upDateListBoss
        }
      }),
      _c("alertModal", { ref: "alertModal" }),
      _c("loader", { ref: "loaderModal", attrs: { text: _vm.loaderText } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ff0f7d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ff0f7d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/channels/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3ff0f7d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/channels/index.vue
// module chunks = 6